(function() {
  'use strict';

  function filter() {
    return function(content) {
      if (!content) {
        return '';
      }

      // Capture all attributes (including class, id, rel, etc.)
      var regexp = /<\s*a\s+([^>]*href="(.*?)"[^>]*)>(.*?)<\s*\/\s*a\s*>/gi;

      if (content.search(regexp) !== -1) {
        content = content.replace(regexp, function(_, attrs, _href, inner) {
          // Rebuild the anchor, keeping all attributes and adding target="_blank"
          // Avoid duplicate target attribute if it already exists
          if (!/target\s*=/.test(attrs)) {
            attrs += ' target="_blank"';
          }
          return '<a ' + attrs + '>' + inner + '</a>';
        });
      }

      return content;
    };
  }

  filter.$inject = ['$sce', '$log'];

  angular.module('blocks.utils')
    .filter('a2nt', filter);
})();

